import axios from 'axios';

const aclInstance = axios.create({
	baseURL: process.env.ACL_URL,
	// transformResponse(response) {
	// 	if (response.status >= 200 || response.status <= 299) {
	// 		return response.data.data;
	// 	}
	// 	return response;
	// },
});

const mockInstance = axios.create({
	baseURL: process.env.MOCK_URL,
});

const salesInstance = axios.create({
	baseURL: process.env.SALES_URL,
});

const companyInstance = axios.create({
	baseURL: process.env.ACL_URL_COMPANY,
});

export default function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$http = aclInstance;
	Vue.prototype.$httpMock = mockInstance;
	Vue.prototype.$httpSales = salesInstance;
	Vue.prototype.$httpCompany = companyInstance;
}



// WEBPACK FOOTER //
// ./src/axios.js